import { IScript } from "./IScript"

export interface IScheduledJob {
    Id: string
    QAId: string
    AccountId: string
    AccountName: string
    Name: string
    Category: string
    QAScript: boolean
    CronExpression: string
    QACronExpression: string
    LastRunTime: string | Date
    NextRunTime: string | Date
    CurrentScript: IScript
    CurrentQAScript: IScript
    LoomDetails: ILoomDetails
    MondayDetails: IMondayDetails
    BusinessRequirement: IBusinessRequirement
    ShowDiff: boolean
    ShowLog: boolean
    InProcess: boolean
    LongRunning: boolean
    Description: string
    Enabled: boolean
    System: boolean
    CanClientView?: boolean
    ReadOnly: boolean
    LLMTraining: boolean
    Type: EScheduledJobType
    Version: EScheduledJobVersion
    Progress?: IJobProgress
    AverageMinutesToFinish: number
    StandardJobVariables: IStandardJobVariables
}

export interface IStandardJobVariables
{
    EmailList: string
    QAEmailList: string
}

export interface IMondayDetails
{
    MondayURL: string
}

export interface ILoomDetails
{
    LoomVideoURL: string
    LoomVideoTranscript: string
}

export interface IBusinessRequirement
{
    BusinessRequirement: string
    DiDiDescription: string
    IsFromMonday: boolean
    LastModifiedDate: string | Date
    LastModifiedByName: string
}

export interface IJobProgress{
    ProgressText: string
    TotalProgress: number
    ProgressCount: number
    TotalSubProgress: number
    SubProgressCount: number
    SubProgressText: string
}

export enum EScheduledJobType {
    General,
    PayrollTimeExport
}

export enum EScheduledJobVersion {
    V1 = 0,
    V2 = 1
}